import React from 'react'
import { cellDescriptor } from '../lib/geometry'
import { BODY_FONT, HEAD_FONT } from '../lib/palette'
import { primaryBtn } from '../lib/styles'

const ReflectionList = ({ palette, cell, items, onEdit, onAdd }) => {
    const styles = {
        listMeta: { fontSize: '18px', fontFamily: HEAD_FONT, fontWeight: 600, marginBottom: '18px' },
        listWrap: { display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '8px' },
        listRow: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            padding: '12px 14px',
            borderRadius: '10px',
            border: `1px solid ${palette.line}`,
            background: 'transparent',
            fontFamily: BODY_FONT,
            color: palette.ink,
            textAlign: 'left',
            cursor: 'pointer',
        },
        listRowTitle: { display: 'block', fontSize: '14px', fontWeight: 500 },
        listRowDate: { display: 'block', fontSize: '12px', color: palette.sub, marginTop: '2px' },
        listRowArrow: { fontSize: '12px', color: palette.sub },
        emptyNote: { fontSize: '14px', color: palette.sub, margin: '0 0 8px', lineHeight: 1.5 },
        actions: { display: 'flex', gap: '10px', marginTop: '10px', flexWrap: 'wrap' },
        primaryBtn: primaryBtn(palette),
    }

    return (
        <>
            <div style={styles.listMeta}>{cellDescriptor(cell)}</div>
            {items.length > 0 ? (
                <div style={styles.listWrap}>
                    {items.map(it => (
                        <button key={it.id} style={styles.listRow} onClick={() => onEdit(it)} aria-label={`Edit ${it.title}`}>
                            <span>
                                <span style={styles.listRowTitle}>{it.title}</span>
                                <span style={styles.listRowDate}>{it.date}</span>
                            </span>
                            <span style={styles.listRowArrow}>Edit</span>
                        </button>
                    ))}
                </div>
            ) : (
                <p style={styles.emptyNote}>Nothing here yet — add your first reflection for this part of the map.</p>
            )}
            <div style={styles.actions}>
                <button style={styles.primaryBtn} onClick={onAdd}>
                    + Add reflection
                </button>
            </div>
        </>
    )
}

export default ReflectionList
